import '../styles/carousel.css';

function CarouselImage({ text, image, title, comment }) {
  return (
    <div className='carouselImage-wrapper'
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), ${image}`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
      }}
    >
      <h1 className='item-title' style={{
        fontWeight: "bold",
        textShadow: "0 2px 6px rgba(0,0,0,0.55), 0 8px 18px rgba(0,0,0,0.55), 0 16px 36px rgba(0,0,0,0.45), 0 28px 60px rgba(0,0,0,0.35)"
      }}>{title}</h1>
      <h2 className='item-desc' style={{
        fontWeight: "BOLD",
        textShadow: "0 2px 6px rgba(0,0,0,0.55), 0 8px 18px rgba(0,0,0,0.55), 0 16px 36px rgba(0,0,0,0.45), 0 28px 60px rgba(0,0,0,0.35)"
      }}>{text}</h2>
      <h3 className='item-desc2' style={{
        fontWeight: "500",
        textShadow: "0 2px 6px rgba(0,0,0,0.55), 0 8px 18px rgba(0,0,0,0.55), 0 16px 36px rgba(0,0,0,0.45), 0 28px 60px rgba(0,0,0,0.35)"
      }}>{comment}</h3>
    </div>
  );
  }
  
  export default CarouselImage;